<template>
  <div class="custom-recipe">
    <AppHeader></AppHeader>

    <div class="page-wrapper">
      <div class="container-fluid">
        

				<!-- Title -->
				<div class="row heading-bg">
					<div class="col-xs-12">
						<h5 style="margin-left:20px;" class="txt-dark pull-left">Add Custom Recipe</h5>
					</div>
				</div>
				<!-- /Title -->
				<div class="row">
					<div class="col-md-5">
						<div class="form-group col-md-12">
							<input type="text" class="form-control" placeholder="Recipe Name" v-model="newrecipe.name">
						</div>
						<div class="form-group col-md-12">
							<textarea name="" id="" placeholder="Description" cols="30" rows="5" class="form-control" v-model="newrecipe.description"></textarea>
						</div>
						<div class="form-group col-md-4">
							<input type="text" class="form-control" placeholder="Preparation Time" v-model="newrecipe.preperation_time">
						</div>
						<div class="form-group col-md-4">
							<input type="text" class="form-control" placeholder="Cooking Time" v-model="newrecipe.cooking_time">
						</div>
						<div class="form-group col-md-4">
							<input type="text" class="form-control" placeholder="Serves" v-model="newrecipe.servings">
						</div>
						<div class="form-group col-md-12">
							<textarea class="form-control" rows="10" placeholder="Instructions" v-model="newrecipe.instructions"></textarea>
						</div>
						<div class="form-group col-md-12">
							<label for="">Recipe Photo</label>
							<button type="button" @click="$refs.file.click()" class="btn btn-block btn-nutri-green">Upload Photo</button>
							<input v-show="false" type="file" id="file" ref="file" v-on:change="handleFileUpload()" class="form-control" />
						</div>
						<div class="col-md-12">
							<h5>Ingredients</h5>
							<table class="col-md-12 table table-responsive" id="recipeingredients" v-if="newrecipe.ingredients.length > 0">
								<tr>
									<th>Ingredient</th>
									<th>Quantity</th>
									<th>Measurement</th>
									<th>Remove</th>
								</tr>

								<tr v-for="(value, index) in newrecipe.ingredients" :key="index">
									<td style="width:50%;">
										{{value.html_name}}
									</td>
									<td style="width:20%;">
										<input type="text" class="form-control" v-model="value.quantity" />
									</td>
									<td style="width:30%;">
										<select name="" id="" class="form-control" v-model="value.selected_measurement">
											<option v-for="(v, i) in JSON.parse(value.measurements_data)" :value="i" :key="i">{{v.measurement_name}}</option>
										</select>
									</td>
									<td style="text-align:center;">
										<i style="font-size:26px;" @click="removeIngredient(index)" class="fa fa-times-circle"></i>
									</td>
								</tr>
							</table>
							<input type="text" class="form-control" placeholder="Search Ingredients" v-on:keyup.13="currentPage=1; getFood();" v-model="searchTerm">
							<button style="margin-top:10px;margin-bottom:10px;" type="button" @click="currentPage=1; getFood();" class="btn btn-block btn-nutri-green">Search Ingredients</button>
							<div class="alert-info" v-if="show_loader" style="text-align:center;padding:5px;margin-bottom:5px;">Loading Ingredients...</div>
							<div id="searchResultsContainer" v-if="searchResults != null">
								<h6>Matching Foods:</h6>
								<ul>
									<li class="searchResult" v-for="(item, index) in searchResults" v-bind:key="index">
										<a href="javascript:void(0)" v-html="item.html_name" v-on:click="addIngredientToRecipe(item.id)"></a>
									</li>
								</ul>
								<a href="javascript:void(0)" v-on:click="currentPage++; getFood()" class="btn btn-nutri-green form-control" style="color:white;">Load More</a>
							</div>
						</div>
						<div class="col-md-12" style="margin-top:30px;" >
							<button ref="RecipeCreate" href="#" class="btn btn-nutri-green full-width" data-toggle="modal" data-target="#exampleModal">Create Recipe</button>
						</div>
					</div>
					<div class="col-md-7">

						<div class="panel panel-default card-view panel-refresh">
							<div class="refresh-container">
								<div class="la-anim-1"></div>
							</div>
							<div class="panel-wrapper collapse in">
								<div class="panel-body">
									<div class="col-md-3" v-if="newrecipe.photo_url">
										<div class="item-big">
											<img class="img-responsive" :src="newrecipe.photo_url == null ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : newrecipe.photo_url"
											   alt="">
										</div>
									</div>
									<div class="col-md-9">
										<div class="product-detail-wrap">
											<h3 class="mb-20 weight-500" v-if="newrecipe.name">{{newrecipe.name}}</h3>
											<p v-if="newrecipe.description">{{newrecipe.description}}</p>
											<h5 v-if="newrecipe.ingredients.length > 0">Ingredients</h5>
											<ul v-if="newrecipe.ingredients.length > 0">
												<li v-for="(ingredient, key) in newrecipe.ingredients" :key="key">{{ingredient.quantity}} {{JSON.parse(ingredient.measurements_data)[0].measurement_name}} {{ingredient.html_name}}
												</li>
											</ul>
											<div v-if="newrecipe.instructions">
												<h5>Directions</h5>
												{{newrecipe.instructions}}
											</div>
										</div>
										<div class="col-md-12" v-if="newrecipe.preperation_time">
											<label for="Quantity">Preparation Time: {{newrecipe.preperation_time}}</label>
										</div>
										<div class="col-md-12" v-if="newrecipe.cooking_time">
											<label for="Quantity">Cooking Time: {{newrecipe.cooking_time}}</label>
										</div>
										<div class="col-md-12" v-if="newrecipe.servings">
											<label for="Quantity">Serves: {{newrecipe.servings}}</label>
										</div>
									</div>
								</div>
								<p v-if="newrecipe.name == null" class="text-center">Recipe Preview</p>
							</div>
						</div>
					</div>
				</div>
				<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Create Recipe</h5>
						</div>
						<div class="modal-body">
							Are you sure you want to create this recipe?
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="createRecipe">Okay</button>
						</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <loading :active.sync="isLoading"></loading>
	</div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter.vue";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import { mapMutations } from "vuex";
const api = new API();

export default {
	components: {
		AppHeader,
		AppFooter,
		swal,
    Loading,
	},
	data() {
		return {
			isLoading: false,
			newrecipe: {
				name: null,
				description: null,
				preperation_time: null,
				cooking_time: null,
				servings: null,
				instructions: null,
				photo_url: null,
				ingredients: [],
			},
			searchTerm: null,
			searchResults: null,
			currentPage: 1,
			show_loader: false,
		}
	},
	created() {},
	methods: {
		addIngredientToRecipe: function(id) {
			api.getIngredientById(id).then(async response => {
				let ingredientChosen = response.data.data;
				ingredientChosen.quantity = 1;
				ingredientChosen.selected_measurement = 0;
				this.newrecipe.ingredients.push(ingredientChosen); 
				this.searchResults = null; 
				this.searchTerm = null
			});
		},
		removeIngredient(value){			
			this.newrecipe.ingredients.splice(value, 1)
		},
		handleFileUpload() {
			const elem = this.$refs.RecipeCreate;
        
        		elem.disabled = true;

      elem.disabled = true;

      api
        .uploadPhoto("recipes", this.$refs.file.files[0])
        .then(async response => {
          if (response.data.success) {
            this.newrecipe.photo_url = response.data.data;
            elem.disabled = false;
          }
        });
    },
    getFood: function() {
      if (this.searchTerm != null && this.searchTerm != "") {
        this.searching = true;
        this.show_loader = true;
        if (this.currentPage == 1) {
          this.searchResults = null;
        }

        api
          .searchFood(this.searchTerm, this.currentPage)
          .then(async response => {
            if (response.data.success) {
              this.searching = false;
              if (this.currentPage == 1) {
                this.searchResults = response.data.data.data;
              } else {
                for (var r = 0; r < response.data.data.data.length; r++) {
                  this.searchResults.push(response.data.data.data[r]);
                }
              }
              this.show_loader = false;
            }
          });
      }
    },
    createRecipe() {
			this.isLoading = true;
      api.createCustomRecipe(this.newrecipe).then(async response => {
        if (response.data.success) {
					this.isLoading = false;
          swal("Recipe Created!", "Custom Recipe Created!", "success");
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
						swal.close();
					}, 4000);
        }
      });
    }
  }
};
</script>

<style scoped>
#searchResultsContainer {
  height: 300px;
  padding: 5px;
  overflow: auto;
}
.searchResult {
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  padding: 10px 5px;
  background: #f5f5f5;
}

#recipeingredients td,
#recipeingredients th {
  padding: 15px;
  border: 1px solid #c2c2c2;
}
</style>


// WEBPACK FOOTER //
// src/views/FoodTracking/AddCustomRecipe.vue